export default "__VITE_ASSET__nBMjfc1y__"